import React from "react";
import Bundles from "src/pages/watcher/Bundles";
import ShowBundle from "src/pages/watcher/Bundles/Show";
import R2Files from "src/pages/watcher/R2Files";
import Admins from "src/pages/watcher/Admins";
import RequireCapability from "src/componets/RequireCapability";

const watcherRoutes = [
  { path: '/bundles', element: <Bundles /> },
  { path: '/bundles/:id',   element: <ShowBundle /> },
  { path: '/r2-files', element: <R2Files /> },
  {
    path: '/admins',
    element: (
      <RequireCapability capability='manage_admins'>
        <Admins />
      </RequireCapability>
    )
  },
]

export default watcherRoutes;
